<div class="offer-card">
  <img
    class="offer-card__image"
    [src]="imageSrc"
    [alt]="imageAlt"
    [attr.width]="imageWidth"
    [attr.height]="imageHeight"
  />
  <div class="offer-card__content">
    <h2 class="offer-card__title">
      {{ heading }}
      <img
        *ngIf="titleIconSrc"
        class="offer-card__title-icon"
        [src]="titleIconSrc"
        alt=""
        width="18"
        height="18"
      />
    </h2>
    <span class="offer-card__text">{{ text }}</span>
    <div class="offer-card__actions">
      <a
        *ngIf="linkUrl; else linkButton"
        class="offer-card__link"
        [href]="linkUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ linkLabel }}
      </a>
      <ng-template #linkButton>
        <button type="button" class="offer-card__link" (click)="linkClick.emit()">
          {{ linkLabel }}
        </button>
      </ng-template>
    </div>
  </div>
</div>
